import { css, html, LitElement } from "lit";
import {property, customElement} from 'lit/decorators.js';
import { FiSubView, UiStateModel, UiStateModelParam } from "../../../src/models/ui-state-model";

import "./voy-fleet-sub-view-vessel";
import "./voy-fleet-sub-view-list";
import "./voy-fleet-sub-view-schedule";
import "./voy-fleet-sub-view-vessel-alarms";
import "./voy-fleet-sub-view-vessel-alarms-log";
import "../../voy-past-trail-view/src/voy-past-trail-view";
import "./voy-fleet-sub-view-alarm-details";
import "./voy-fleet-sub-view-nearest-port";
import "./voy-fleet-sub-view-port-view";
import "./voy-fleet-sub-view-port-view-expected-arrivals";
import { VoyageShoreContextModel } from "../../../src/models/voyage-shore-context-model";
import { ShoreContextEvent } from "../../../src/models/types/voyage-shore-context-model.types";

@customElement('voy-fleet-sub-view-container')
export class VoyFleetSubViewContainer extends LitElement {
    @property({ type: String, attribute: false }) 
    private _currentView?: string;
    @property({ type:Boolean, attribute: 'time-line-visible', reflect: true}) private  _timeLineVisible : boolean =  false;

    constructor() {
        super();

        this._updateCurrentView = this._updateCurrentView.bind(this);
        this._toggleTimeLine = this._toggleTimeLine.bind(this);
        if(localStorage.getItem("timeLineView")!==undefined) {
            this._timeLineVisible = localStorage.getItem("timeLineView")=="true";
        }
    }

    static get styles() {
        return [
            css`
                :host {
                    position: fixed;
                    top: 106px;
                    width: 324px;
                    display: block;
                    overflow: hidden;
                    background-color: var(--neutrals-grey-10, white);
                    z-index: 3;
                    font-family: var(--component-paragraph-ff);
                    box-shadow: 2px 2px 8px var(--secondary-voyage-box-shadow);
                }

                :host([time-line-visible]) {
                    height: 78vh;   
                }

                #not-found {
                    padding: 16px;
                }
            `
        ];
    }

    render() {
        const imo = UiStateModel!.getValue(UiStateModelParam.IMO);
        const portRegion = UiStateModel!.getValue(UiStateModelParam.PortRegion);
        const portCityId = UiStateModel!.getValue(UiStateModelParam.PORT);

        if (portRegion || portCityId) {
            switch (this._currentView) {
                case FiSubView.PortView:
                    return html`<voy-fleet-sub-view-port-view .portCityId=${portCityId}></voy-fleet-sub-view-port-view>`;

                case FiSubView.PortViewExpectedArrivals:
                    return html`<voy-fleet-sub-view-vessel-list></voy-fleet-sub-view-vessel-list>`;
                    // To be implemented, decision on user input whether to do this or not
                    return html`<voy-fleet-sub-view-port-view-expected-arrivals .imo=${17}></voy-fleet-sub-view-port-view-expected-arrivals>`;

                case FiSubView.PortsByRegionView:
                    return html`<voy-fleet-sub-view-port-view .ocl=${portRegion}></voy-fleet-sub-view-port-view>`;
            }
        }

        if (!imo) {
            UiStateModel!.setValue(UiStateModelParam.FISubView);
            return html`<voy-fleet-sub-view-list></voy-fleet-sub-view-list>`;
        }

        const imoNo = parseInt(imo);

        switch (this._currentView) {
            case FiSubView.AlarmDetails:
                return html`
                    <voy-fleet-sub-view-alarm-details .imo=${imoNo}></voy-fleet-sub-view-alarm-details>
                `;

            case FiSubView.NearestPort:
                return html`<voy-fleet-sub-view-nearest-port .imo=${imoNo}></voy-fleet-sub-view-nearest-port>`;

            case FiSubView.VesselAlarms:
                return html`
                    <voy-fleet-sub-view-vessel-alarms .imo=${imoNo}></voy-fleet-sub-view-vessel-alarms>`;
            
            case FiSubView.VesselNotificationsLog:  
            case FiSubView.VesselAlarmsLog:
                return html`
                    <voy-fleet-sub-view-vessel-alarms-log .imo=${imoNo}></voy-fleet-sub-view-vessel-alarms-log>`;
                
            case FiSubView.VesselDetails:    
                return html`
                    <voy-fleet-sub-view-vessel .imo=${imoNo}></voy-fleet-sub-view-vessel>`;
                        
            case FiSubView.ListView: 
                return html`<voy-fleet-sub-view-list></voy-fleet-sub-view-list>`;
                        
            case FiSubView.VesselPastTrail: 
                return html`<voy-past-trail-view .imo=${imoNo}></voy-past-trail-view>`;
                        
            case FiSubView.VesselSchedule:
                return html`
                    <voy-fleet-sub-view-schedule .imo=${imoNo}></voy-fleet-sub-view-schedule>
                `;

            default:
                return html`<voy-fleet-sub-view-list></voy-fleet-sub-view-list>`;
        }
    }

    connectedCallback() {
        super.connectedCallback();


        if (UiStateModel!.getValue(UiStateModelParam.FISubView)) {
            this._currentView = UiStateModel!.getValue(UiStateModelParam.FISubView)!;
        }

        UiStateModel!.addEventListener(`${UiStateModelParam.FISubView}-change`, this._updateCurrentView);
        UiStateModel!.addEventListener(`${UiStateModelParam.IMO}-change`, this._updateCurrentView);
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.TimeLineViewToggle, this._toggleTimeLine);  
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        UiStateModel!.removeEventListener(`${UiStateModelParam.FISubView}-change`, this._updateCurrentView);
        UiStateModel!.removeEventListener(`${UiStateModelParam.IMO}-change`, this._updateCurrentView);
    }

    private _updateCurrentView() {
        this._currentView = UiStateModel!.getValue(UiStateModelParam.FISubView) || "";
        this.requestUpdate();
    }

    private _toggleTimeLine():void {
        this._timeLineVisible = !this._timeLineVisible
    }
}
